import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import html from "csi/html";
import xml from "csi/xml";
import NewPaneForm from "./NewPaneForm";
import HomePageUtil from "./util";
import NewItemPaneForm from "./NewItemPaneForm";

const NewSourcingPaneForm = declare(NewItemPaneForm, {
	allowedPaneIds: [
		"HomeFactory",
		"HomeFoodSupplierItem",
		"HomeFormulatedMaterialSupplierItem",
		"HomeInspirationQuotes",
		"HomeInspirationStyleRequests",
		"HomeOrder",
		"HomePurchasedOrder",
		"HomeSupplier",
		"HomeSupplierItem",
		"HomeSupplierRequest",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [];
	},
});

export = NewSourcingPaneForm;